// react
import { useContext } from "react";

// context
import ProductContext from "../../context/ProductContext";

// components
import CartItem from "./CartItem";
// import CartTotal from "./CartTotal";
import CartNavigation from "./CartNavigation";
import Shelf from "../shelf/shelf.component";
import { Heading } from "../heading/Heading";

// styles
import "./addToCartModal.styles.scss";
import { useEffect } from "react";

const AddToCartModal = (...props: any) => {
  const context: any = useContext(ProductContext);

  const {
    productState: { Quantity },
  }: {
    productState: {
      Quantity: number;
    };
  } = context;

  const ItemDisplayHandler = () => (Quantity == 1 ? "item" : "items");

  useEffect(() => {
    ItemDisplayHandler();
  }, [Quantity]);

  return (
    <div className="addToCartModal">
      <div className="addToCartModal-bd">
        <Shelf mobile="30" tablet="30" desktop="30">
          <div className="addToCartModal-bd-qty">
            <Heading
              className={"hdg hdg_h5 hdg_neutral"}
              element="h3"
              {...props}
            >
              ({Quantity}) {ItemDisplayHandler()} added to your cart
            </Heading>
          </div>
        </Shelf>
        <CartItem />
      </div>
      <div className="addToCartModal-ft">
        {/* <CartTotal /> */}
        <CartNavigation />
      </div>
    </div>
  );
};

export default AddToCartModal;
